export default (way) => {
  if (!way || !way.fragments) return null;
  const [fragment] = way.fragments;
  return fragment.trip.allowsSeatSelection;
};
